/**
 * 各页面 SEO 数据集中配置
 *
 * 每个页面 slug 对应一组 title/description 三语版
 * 11 个页面 × 3 语言 = 33 条 SEO 数据
 *
 * 所有描述均基于真实公开信息（i18n 翻译 + 官网文案），不编造
 */

export const PAGE_SEO = {
  // 首页
  home: {
    slug: '',
    title: {
      zh: '小麦铺布机 | X5/X6 全自动无张力铺布机厂家 - 龙南小麦自动化科技有限公司',
      en: 'Xiaomai Spreader | X5/X6 Automatic Tension-free Spreading Machine Manufacturer',
      vi: 'Máy trải vải Xiaomai | Nhà sản xuất máy trải vải tự động X5/X6',
    },
    description: {
      zh: '小麦铺布机是龙南小麦自动化科技有限公司旗下品牌，2012 年成立，主营 X5/X6 全自动无张力铺布机及子母机，覆盖服装、家纺、汽车内饰、箱包、复合材料行业。全国服务热线 400-050-1183。',
      en: 'Xiaomai Spreader is a brand of Longnan Xiaomai Automation Technology Co., Ltd., founded in 2012, specializing in X5/X6 automatic tension-free spreading machines and composite (parent-child) machines for garment, home textile, automotive interior, luggage and composite materials industries. Hotline: 400-050-1183.',
      vi: 'Máy trải vải Xiaomai là thương hiệu của Công ty TNHH Công nghệ Tự động hóa Xiaomai Long Nam, thành lập năm 2012, chuyên sản xuất máy trải vải tự động X5/X6 và máy mẹ-con cho ngành may mặc, dệt gia dụng, nội thất ô tô, hành lý và vật liệu composite. Hotline: 400-050-1183.',
    },
  },

  // 关于我们
  about: {
    slug: 'about',
    title: {
      zh: '关于小麦铺布机 - 龙南小麦自动化科技有限公司 | 2012 年成立',
      en: 'About Xiaomai Spreader - Longnan Xiaomai Automation Technology Co., Ltd. | Est. 2012',
      vi: 'Về Máy trải vải Xiaomai - Công ty TNHH Công nghệ Tự động hóa Xiaomai Long Nam | Thành lập 2012',
    },
    description: {
      zh: '龙南小麦自动化科技有限公司成立于 2012 年，投资 1.2 亿元，生产场所超 15000 平方米，配备激光切割机、折弯机、自动焊机、喷涂线、抛丸机等大型设备。2019 年在江西龙南设立生产基地。',
      en: 'Longnan Xiaomai Automation Technology Co., Ltd. was founded in 2012, with a total investment of 120 million yuan and a production area of more than 15,000 square meters. In 2019, the company established a production base in Longnan, Jiangxi Province.',
      vi: 'Công ty TNHH Công nghệ Tự động hóa Xiaomai Long Nam được thành lập năm 2012, với tổng vốn đầu tư 120 triệu nhân dân tệ và diện tích sản xuất hơn 15.000 mét vuông. Năm 2019, công ty đã thành lập cơ sở sản xuất tại Long Nam, Giang Tây.',
    },
  },

  // 生产能力
  capacity: {
    slug: 'capacity',
    title: {
      zh: '生产能力 - 小麦铺布机 | 15000m² 厂房 + 双厂区',
      en: 'Production Capacity - Xiaomai Spreader | 15,000m² + Dual Plant',
      vi: 'Năng lực sản xuất - Máy trải vải Xiaomai | 15.000m² + Hai nhà máy',
    },
    description: {
      zh: '小麦自动化拥有 15000m² 厂房，配备激光切割机、折弯机、自动焊接机、喷涂机、抛丸机等大型自动化生产设备，可同时满足公司内部零件加工与对外代工需求。',
      en: 'Xiaomai operates a 15,000m² production facility equipped with laser cutting machines, bending machines, automatic welding machines, spray painting lines, shot blasting machines and other large-scale automation equipment, capable of both in-house parts manufacturing and external processing services.',
      vi: 'Xiaomai sở hữu cơ sở sản xuất 15.000m² được trang bị máy cắt laser, máy uốn, máy hàn tự động, dây chuyền phun sơn, máy phun bi và các thiết bị tự động hóa quy mô lớn khác.',
    },
  },

  // 小麦优势
  advantage: {
    slug: 'advantage',
    title: {
      zh: '小麦九大优势 - X5/X6 铺布机核心技术解析',
      en: 'Nine Core Advantages of Xiaomai Spreader - X5/X6 Technology',
      vi: 'Chín lợi thế cốt lõi của Máy trải vải Xiaomai - Công nghệ X5/X6',
    },
    description: {
      zh: '小麦铺布机九大核心技术优势：伺服电机动力系统、缓存装置、智能送料、专利展平装置、光电纠边、伺服送料、弹性自动跟踪、30 种面料记忆、铺布效果平整对齐。',
      en: 'Nine core technological advantages: servo motor power system, fabric caching device, intelligent feeding, patented flattening device, photoelectric edge correction, servo feeding, elastic auto-tracking, 30-fabric memory, flat and aligned spreading effect.',
      vi: 'Chín lợi thế công nghệ cốt lõi: hệ thống servo, thiết bị đệm vải, cấp liệu thông minh, thiết bị làm phẳng được cấp bằng sáng chế, hiệu chỉnh cạnh quang điện, cấp liệu servo, theo dõi đàn hồi tự động, bộ nhớ 30 loại vải, hiệu quả trải phẳng và thẳng hàng.',
    },
  },

  // 产品总览
  products: {
    slug: 'products',
    title: {
      zh: '产品中心 - 小麦铺布机 X5/X6/子母机全系列',
      en: 'Products - Xiaomai Spreader X5/X6/Composite Machine Full Series',
      vi: 'Trung tâm sản phẩm - Máy trải vải Xiaomai X5/X6/Máy mẹ-con Toàn bộ dòng sản phẩm',
    },
    description: {
      zh: '小麦自动化提供 X5 全自动铺布机、X6 无张力铺布机、母子铺布机三大系列产品，铺布宽度 1600~3100mm，最大布料重量 110kg，适用服装、家纺、汽车内饰、箱包、复合材料。',
      en: 'Xiaomai offers three product series: X5 automatic spreading machine, X6 tension-free spreading machine, and parent-child spreading machine. Spreading width 1600~3100mm, max fabric weight 110kg, suitable for garment, home textile, automotive interior, luggage, and composite materials.',
      vi: 'Xiaomai cung cấp ba dòng sản phẩm: máy trải vải tự động X5, máy trải vải không lực căng X6, và máy trải vải mẹ-con. Chiều rộng trải 1600~3100mm, trọng lượng vải tối đa 110kg.',
    },
  },

  // X5 详情
  x5: {
    slug: 'x5',
    title: {
      zh: '小麦 X5 全自动铺布机 - 1600~3100mm / 110kg / PLC 控制',
      en: 'Xiaomai X5 Automatic Spreading Machine - 1600~3100mm / 110kg / PLC Control',
      vi: 'Máy trải vải tự động Xiaomai X5 - 1600~3100mm / 110kg / Điều khiển PLC',
    },
    description: {
      zh: 'X5 系列全自动铺布机：5 个型号（X5-160/190/210/260/310），铺布宽度 1600~3100mm，最大布料重量 110kg，最大驱动速度 85~88m/min，微电脑 PLC 综合控制，支持 30 种面料参数记忆。',
      en: 'X5 series automatic spreading machine: 5 models (X5-160/190/210/260/310), spreading width 1600~3100mm, max fabric weight 110kg, max driving speed 85~88m/min, PLC microcomputer control, supports 30-fabric parameter memory.',
      vi: 'Dòng máy trải vải tự động X5: 5 mẫu (X5-160/190/210/260/310), chiều rộng trải 1600~3100mm, trọng lượng vải tối đa 110kg, tốc độ lái tối đa 85~88m/min, điều khiển PLC vi máy tính, hỗ trợ bộ nhớ tham số 30 loại vải.',
    },
  },

  // X6 详情
  x6: {
    slug: 'x6',
    title: {
      zh: '小麦 X6 无张力铺布机 - 电脑控制智能无张力模块',
      en: 'Xiaomai X6 Tension-free Spreading Machine - Computer-controlled Smart Tension-free Module',
      vi: 'Máy trải vải không lực căng Xiaomai X6 - Mô-đun không lực căng thông minh điều khiển bằng máy tính',
    },
    description: {
      zh: 'X6 无张力铺布机在 X5 基础上增加电脑控制智能无张力铺布模块，适用男女内衣、T 恤、保暖衣等高弹面料，避免裁剪前回缩变形。5 个型号 X6-160/190/210/260/310。',
      en: 'X6 tension-free spreading machine adds a computer-controlled smart tension-free spreading module to the X5, ideal for high-elasticity fabrics such as underwear, T-shirts, and thermal wear, preventing shrinkage deformation before cutting. 5 models X6-160/190/210/260/310.',
      vi: 'Máy trải vải không lực căng X6 bổ sung mô-đun trải không lực căng thông minh điều khiển bằng máy tính cho X5, lý tưởng cho vải có độ đàn hồi cao như đồ lót, áo thun và đồ giữ nhiệt.',
    },
  },

  // 子母机
  zm: {
    slug: 'zm',
    title: {
      zh: '小麦子母铺布机 - 复合材料专用 多层铺布设备',
      en: 'Xiaomai Parent-Child Spreading Machine - Composite Material Multi-layer Spreading',
      vi: 'Máy trải vải mẹ-con Xiaomai - Trải đa lớp vật liệu composite',
    },
    description: {
      zh: '母子铺布机可同时处理多种面料，专为多层及特殊材质设计，适用碳纤维预浸料、玻纤、芳纶等复合材料。4 个型号 ZM-160/190/210/220，最大布料重量 200kg。',
      en: 'Parent-Child spreading machine can process multiple fabrics simultaneously, designed for multi-layer and specialty materials, suitable for carbon fiber prepreg, fiberglass, aramid and other composite materials. 4 models ZM-160/190/210/220, max fabric weight 200kg.',
      vi: 'Máy trải vải mẹ-con có thể xử lý nhiều loại vải cùng lúc, được thiết kế cho vật liệu nhiều lớp và đặc biệt, phù hợp với prepreg sợi carbon, sợi thủy tinh, aramid và các vật liệu composite khác.',
    },
  },

  // 视频集锦
  spreaders_video: {
    slug: 'spreaders_video',
    title: {
      zh: '视频集锦 - X5/X6 铺布机实操演示 | 小麦自动化',
      en: 'Video Highlights - X5/X6 Spreader Live Demo | Xiaomai Automation',
      vi: 'Video tổng hợp - Biểu diễn trực tiếp máy trải X5/X6 | Tự động hóa Xiaomai',
    },
    description: {
      zh: '小麦自动化 X5/X6/子母机 视频集锦：工厂实拍、设备调试、客户落地案例、服装厂运行实景。',
      en: 'Xiaomai X5/X6/Composite machine video highlights: factory live shots, equipment commissioning, customer installation cases, garment factory operation scenarios.',
      vi: 'Tổng hợp video X5/X6/Máy mẹ-con của Xiaomai: cảnh quay trực tiếp tại nhà máy, vận hành thiết bị, trường hợp lắp đặt của khách hàng, tình huống vận hành tại nhà máy may.',
    },
  },

  // 选购指南
  purchase_guide: {
    slug: 'purchase_guide',
    title: {
      zh: '如何选购铺布机 - 5 个核心参数 | 小麦自动化',
      en: 'How to Choose a Spreading Machine - 5 Core Parameters | Xiaomai',
      vi: 'Cách chọn máy trải vải - 5 tham số cốt lõi | Xiaomai',
    },
    description: {
      zh: '选购铺布机重点看 5 个核心参数：最大布料重量、铺布宽度、是否无张力、面料记忆数量、售后服务体系。小麦 X5/X6 系列是国内主流选择。',
      en: 'Choosing a spreading machine: focus on 5 core parameters - max fabric weight, spreading width, tension-free capability, fabric memory count, and after-sales service system. The Xiaomai X5/X6 series is a leading domestic choice.',
      vi: 'Chọn máy trải vải: tập trung vào 5 tham số cốt lõi - trọng lượng vải tối đa, chiều rộng trải, khả năng không lực căng, số lượng bộ nhớ vải và hệ thống dịch vụ sau bán hàng.',
    },
  },

  // 联系我们
  contact: {
    slug: 'contact',
    title: {
      zh: '联系小麦铺布机 - 400-050-1183 | 东莞寮步 + 江西龙南',
      en: 'Contact Xiaomai Spreader - 400-050-1183 | Dongguan Liaobu + Jiangxi Longnan',
      vi: 'Liên hệ Máy trải vải Xiaomai - 400-050-1183 | Long Nam Liễu Bộ + Giang Tây Long Nam',
    },
    description: {
      zh: '小麦铺布机全国服务热线 400-050-1183，邮箱 gnaturepowdef@gmail.com，WhatsApp +86 189-2913-1303。东莞寮步体验中心 + 江西龙南生产基地。',
      en: 'Xiaomai Spreader national hotline 400-050-1183, email gnaturepowdef@gmail.com, WhatsApp +86 189-2913-1303. Dongguan Liaobu experience center + Jiangxi Longnan production base.',
      vi: 'Hotline toàn quốc 400-050-1183, email gnaturepowdef@gmail.com, WhatsApp +86 189-2913-1303. Trung tâm trải nghiệm Long Nam Liễu Bộ + cơ sở sản xuất Giang Tây Long Nam.',
    },
  },

  // 2026 秋季推文（中英双语，内容取自对外发布版 PDF）
  autumn: {
    slug: 'autumn-2026',
    title: {
      zh: '小麦高端智能裁床 1820S-8CM | 2026 秋季推文（中英双语）- 龙南小麦自动化科技有限公司',
      en: 'Xiaomai High-end Intelligent Cutter 1820S-8CM | Autumn 2026 Feature (bilingual) - Longnan Xiaomai Automation',
      vi: 'Máy cắt thông minh Xiaomai 1820S-8CM | Bài viết mùa thu 2026 (song ngữ) - Xiaomai Long Nam',
    },
    description: {
      zh: '小麦 2026 秋季推文（中英双语）：1820S-8CM 高端智能裁床，最高裁剪厚度 8cm，铺布单拉 280mm / 双拉 230mm，漏气工况真空保持为其他品牌 3 倍，床身经 100 万次耐压循环。含三个“不挑”、三个“不断”、四项硬技术、选配清单、回本测算与核心规格速览。',
      en: 'Xiaomai Autumn 2026 feature (bilingual): the 1820S-8CM high-end intelligent cutter — 8cm max cutting thickness, 280mm single / 230mm double spreading pull, 3× vacuum retention under leakage, 1,000,000 pressure cycles on the bed. Includes the three “no-picks”, three “non-stops”, four hard technologies, options, payback estimate and key specifications.',
      vi: 'Bài viết mùa thu 2026 của Xiaomai (song ngữ): máy cắt thông minh cao cấp 1820S-8CM — độ dày cắt tối đa 8cm, trải vải kéo đơn 280mm / kéo đôi 230mm, giữ chân không khi rò khí gấp 3 lần, khung máy chịu 1.000.000 chu kỳ nén. Gồm ba “không kén”, ba “không dừng”, bốn công nghệ cứng, tùy chọn, tính hoàn vốn và thông số chính.',
    },
  },
};

// 共用关键词（覆盖品牌/产品/行业/场景/区域）
const KEYWORD_LIST = [
  // 品牌（中文）
  '小麦铺布机', '龙南小麦', '龙南小麦自动化', '小麦自动化', '东莞小米',
  // 品牌（英文）
  'Xiaomai', 'Xiaomai Spreader', 'Dongguan Xiaomai', 'Longnan Xiaomai',
  // 产品（中文）
  'X5 铺布机', 'X6 铺布机', '子母铺布机', '无张力铺布机', '全自动铺布机',
  '拉布机', '铺布机厂家',
  // 产品（英文）
  'spreading machine', 'automatic spreading machine', 'tension-free spreading machine',
  'fabric laying machine', 'spreader manufacturer', 'X5 spreader', 'X6 spreader',
  // 行业应用
  '服装机械', '家纺机械', '汽车内饰', '箱包机械', '复合材料', '碳纤维预浸料',
  '玻纤铺布', '芳纶', '内衣铺布机', 'T 恤铺布机',
  // 场景
  '源头工厂', '厂家直销', '铺布机价格', '服装厂设备'
];
// 字符串版（用于 build 脚本与 React 运行时直接读取）
export const COMMON_KEYWORDS = KEYWORD_LIST.join(',');
